import { withAuthenticationRequired } from '@auth0/auth0-react'
import { Center, Loader } from '@mantine/core'
import type { ComponentType } from 'react'

const RedirectingFallback = () => (
    <Center h='100%'>
        <Loader />
    </Center>
)

interface ProtectedRouteProps {
    component: ComponentType<unknown>
}

export const ProtectedRoute = ({ component }: ProtectedRouteProps) => {
    const Component = withAuthenticationRequired(component, {
        onRedirecting: RedirectingFallback,
    })

    return <Component />
}

// Higher-order component to protect individual route components
export const withAuth = <P extends object>(Component: ComponentType<P>) => {
    return withAuthenticationRequired(Component, {
        onRedirecting: RedirectingFallback,
    })
}
